import { Button, Icon, Popover, Typography } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import initialAdvertiserInfo from 'modules/Forms/Account/Create/initialAdvertiserInfo'
import AdvertiserTemplateSelector from '../AdvertiserTemplateSelector'
import styles from 'modules/Forms/Account/Create/account-form-creation.module.scss'

const AdvertisersTemplatesField = ({
  headerText = null,
  change = () => {},
}) => {
  const { sm: isMobile } = useBreakpoint()

  const { advertisers } = useSelector((state) => ({
    advertisers: state['advertisers-list'].data,
  }))

  const { t } = useTranslation()

  const { bindTrigger, bindPopover, usePopupState } = Popover.usePopover()

  const popoverState = usePopupState({
    variant: 'popover',
    id: 'advertiser-select-popover',
    breakpoints: {
      0: {
        variant: 'bottomSheet',
        hasBackdrop: true,
        showLabel: true,
        label: t('services::forms.register_account.card_advertiser.header'),
      },
      600: {
        variant: 'modal',
        hasBackdrop: true,
        showLabel: true,
        label: t('services::forms.register_account.card_advertiser.header'),
      },
    },
  })

  const applyTemplate = useCallback(
    (advertiser_template_id) =>
      change(
        'advertiser_info',
        advertisers.find((adv) => adv.id === advertiser_template_id) ||
          initialAdvertiserInfo,
      ),
    [advertisers],
  )

  return (
    <>
      <Typography variant={'Subtitle-25'} className={'margin-bottom-16'}>
        {headerText || t('services::forms.shared_fields.advertiser.info.title')}
      </Typography>
      <Typography
        className={styles['summary']}
        variant={'Body-20'}
        component={'div'}
        color="text-secondary"
        dangerouslySetInnerHTML={{
          __html: t(
            'services::forms.shared_fields.advertiser.info.description',
          ),
        }}
      />

      <Button
        {...bindTrigger(popoverState)}
        fullWidth
        variant={'secondary'}
        size={'l'}
        type={'button'}
        startIcon={<Icon name={'clients'} size={isMobile ? 's' : 'm'} />}
      >
        {t('services::forms.register_account.fields.advertiser_template.label')}
      </Button>

      <Popover
        {...bindPopover(popoverState)}
        className={styles['advertiser-popover']}
        bodyClassName={styles['advertiser-popover__body']}
        headingClassName={styles['advertiser-popover__heading']}
        onClose={() => popoverState.close()}
      >
        <AdvertiserTemplateSelector
          onApply={applyTemplate}
          onClose={() => popoverState.close()}
        />
      </Popover>
    </>
  )
}

AdvertisersTemplatesField.propTypes = {
  headerText: PropTypes.oneOfType([
    PropTypes.oneOf([null]),
    PropTypes.string,
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
  onUpdateAdvertiserData: PropTypes.func,
  change: PropTypes.func,
}

export default AdvertisersTemplatesField
